import request from '@/utils/request';

// 获取资讯内容管理列表
export function getConsultingcontentsList(options) {
  return request({
    url: '/consultingcontents/page',
    method: 'get',
    params: options
  });
}
// 获取资讯内容管理列表
export function consultingTypTree() {
  return request({
    url: '/consultingtypes/consultingTypTree',
    method: 'get'
  });
}
// 创建
export function consultingAdd(options) {
  return request({
    url: '/consultingcontents/',
    method: 'post',
    data: options
  });
}
// 修改
export function consultingEidt(options) {
  return request({
    url: `/consultingcontents/${options.id}`,
    method: 'post',
    data: options
  });
}
// 修改
export function consultingDetails(options) {
  return request({
    url: `/consultingcontents/${options.id}`,
    method: 'get'
  });
}
// 修改状态
export function consultingBatch(options) {
  return request({
    url: `/consultingcontents/batch`,
    method: 'post',
    data: options
  });
}

// 资源类型列表
export function consultingtypesList(options) {
  return request({
    url: `/consultingtypes/page`,
    method: 'get',
    params: options
  });
}

// 资源类型列表
export function consultingtypesBatch(options) {
  return request({
    url: `/consultingtypes/batch`,
    method: 'post',
    data: options
  });
}
// 资源类型列表
export function consultingtypesAdd(options) {
  return request({
    url: `/consultingtypes/`,
    method: 'post',
    data: options
  });
}
// 资源类型列表
export function consultingtypesEdit(options) {
  return request({
    url: `/consultingtypes/${options.id}`,
    method: 'post',
    data: options
  });
}
